import {
  selectOrganizationId,
  useGetWorkspacesQuery,
} from '@carboncopyco/data';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

export const useWorkspacesMap = () => {
  const organizationId = useSelector(selectOrganizationId);
  const { data: workspaces = [] } = useGetWorkspacesQuery({
    organizationId,
  });

  return useMemo(
    () =>
      Object.fromEntries(
        workspaces?.map((workspace) => [workspace.id, workspace])
      ),
    [workspaces]
  );
};
